import isStreamMonkey from '../../utils/isStreamMonkey';

// How many broadcast imports to load from the account migration
const PAGE_SIZE = 500;

// Where to break between small/large (show more/fewer)
const SMALL_LARGE_BREAK = 20;

export default class MigrationProgressController {
  constructor($rootScope, $state, $http, User, Account) {
    'ngInject';
    this.rootScope = $rootScope;
    this.account = $rootScope.account;
    this.accountInfo = Account.getBilling();
    this.user = User;
    this.$state = $state;
    this.$http = $http;
    this.smallItems = [];
    this.longTimes = [];
    this.toggleLong = false;
    this.notMigrated = false;
    this.totalCompleted = 0;
    this.smallLargeBreak = SMALL_LARGE_BREAK;

    this.isStreamMonkey = isStreamMonkey(this.account.migration_service_id);

    this.updateBroadcastList();

    if (this.account.status != 'onboarding') {
      this.$state.go('complete-migration.success');
    }
  }

  toggleShow() {
    this.toggleLong = !this.toggleLong;
  }

  updateBroadcastList() {
    this.$http
      .get(`${API_ROOT}/account/migration/imports?page_size=${PAGE_SIZE}`)
      .then((resp) => {
        const monthsArr = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ];
        this.totalCompleted = 0;
        this.notMigrated = false;
        this.smallItems = [];
        this.longItems = [];
        for (let i = 0; i < resp.data.length; i++) {
          const dateArr = resp.data[i].created_at
            .slice(0, resp.data[i].created_at.indexOf('T'))
            .split('-');

          // Broadcast conversions can happen via either a conversion task or a BoxCast upload.
          // If done via conversion task, the status is in task_status; if done via upload, the
          // status is in upload_status.
          let conversionStatus;
          if (resp.data[i].upload_status) {
            conversionStatus = resp.data[i].upload_status;
          } else if (resp.data[i].task_status) {
            conversionStatus = resp.data[i].task_status;
          } else {
            conversionStatus = 'Not started';
          }

          if (conversionStatus != 'ready') {
            this.notMigrated = true;
          }

          // If the status has a colon followed by some digits, change "foo:XX" to "foo (XX%)" as
          // it's more readable.
          conversionStatus = conversionStatus.replace(
            /([^:]+):(\d+)/,
            (_, p1, p2) => `${p1} (${p2}%)`
          );

          // Capitalize the first letter of the status
          // And if the status is 'ready', show "Imported" instead
          const status =
            conversionStatus === 'ready'
              ? 'Imported'
              : conversionStatus.charAt(0).toUpperCase() + conversionStatus.slice(1);

          if (this.smallItems.length < this.smallLargeBreak) {
            this.smallItems.push({
              name: resp.data[i].name,
              createdAt: `${monthsArr[parseInt(dateArr[1]) - 1]} ${dateArr[2]}, ${dateArr[0]}`,
              tags: resp.data[i].tags.split(','),
              status,
            });
          } else {
            this.longItems.push({
              name: resp.data[i].name,
              createdAt: `${monthsArr[parseInt(dateArr[1]) - 1]} ${dateArr[2]}, ${dateArr[0]}`,
              tags: resp.data[i].tags.split(','),
              status,
            });
          }
          if (conversionStatus == 'ready') {
            this.totalCompleted++;
          }
        }
      })
      .catch(() => false);
  }
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/migration-progress.js